// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__1Oor2","icon":"style_icon__sP3uq","title":"style_title__9O0Gz"};